<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container formArrayName="products">
      @for (product of products.controls; track product; let index = $index) {
        @if (index == 0) {
          <ng-container [formGroup]="product">
            <ng-container formGroupName="parameters">
              <div class="row">
                <pr-input-radio
                  [toggleBgEmpty]="true"
                  formControlName="premiumType"
                  label="Type de cotisations"
                  [options]="[
                    {
                      value: 'CI',
                      label: 'CI',
                    },
                    {
                      value: 'CRD',
                      label: 'CRD',
                    },
                  ]"
                >
                </pr-input-radio>
              </div>
              <div formArrayName="guarantees" class="row">
                <table class="table-bordered table w-full">
                  <thead>
                    <tr>
                      <th>Quotités</th>
                      <th colspan="6">Garanties</th>
                      <th colspan="3">Options</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (
                      guarantee of guarantees.controls;
                      track guarantee;
                      let i = $index
                    ) {
                      <tr [formGroupName]="i">
                        <td>
                          {{ getOwnerLabel(guarantee.get('ownerId').value) }}
                          <span class="text-blue"
                            >{{ guarantee.get('quotite').value * 100 }}%</span
                          >
                        </td>
                        <td
                          formGroupName="dcPtia"
                          [ngClass]="{
                            'checked-required':
                              guarantee.get('dcPtia').get('enabled').value &&
                              guarantee.get('dcPtia').get('required').value,
                            'no-checked-required':
                              !guarantee.get('dcPtia').get('enabled').value &&
                              guarantee.get('dcPtia').get('required').value,
                          }"
                        >
                          <div class="box-garanties">
                            <div class="label-and-checkbox">
                              <span>DC/PTIA</span>
                              <input
                                type="checkbox"
                                formControlName="enabled"
                                class="large-checkbox"
                              />
                            </div>
                          </div>
                        </td>
                        <td
                          formGroupName="ipt"
                          [ngClass]="{
                            'checked-required':
                              guarantee.get('ipt').get('enabled').value &&
                              guarantee.get('ipt').get('required').value,
                            'no-checked-required':
                              !guarantee.get('ipt').get('enabled').value &&
                              guarantee.get('ipt').get('required').value,
                          }"
                        >
                          <div class="box-garanties">
                            <div class="label-and-checkbox">
                              <span>IPT</span>
                              <input
                                type="checkbox"
                                formControlName="enabled"
                                class="large-checkbox"
                              />
                            </div>
                            <mat-select formControlName="typeReglement">
                              @for (option of typeReglementRef; track option) {
                                <mat-option [value]="option.id">
                                  {{ option.label }}
                                </mat-option>
                              }
                            </mat-select>
                          </div>
                        </td>
                        <td
                          formGroupName="ipp"
                          [ngClass]="{
                            'checked-required':
                              guarantee.get('ipp').get('enabled').value &&
                              guarantee.get('ipp').get('required').value,
                            'no-checked-required':
                              !guarantee.get('ipp').get('enabled').value &&
                              guarantee.get('ipp').get('required').value,
                          }"
                        >
                          <div class="box-garanties">
                            <div class="label-and-checkbox">
                              <span>IPP</span>
                              <input
                                type="checkbox"
                                formControlName="enabled"
                                class="large-checkbox"
                              />
                            </div>
                          </div>
                        </td>
                        <td
                          formGroupName="ipm"
                          [ngClass]="{
                            'checked-required':
                              guarantee.get('ipm').get('enabled').value &&
                              guarantee.get('ipm').get('required').value,
                            'no-checked-required':
                              !guarantee.get('ipm').get('enabled').value &&
                              guarantee.get('ipm').get('required').value,
                          }"
                        >
                          <div class="box-garanties">
                            <div class="label-and-checkbox">
                              <span>IPM</span>
                              <input
                                type="checkbox"
                                formControlName="enabled"
                                class="large-checkbox"
                              />
                            </div>
                          </div>
                        </td>
                        <td
                          formGroupName="itt"
                          [ngClass]="{
                            'checked-required':
                              guarantee.get('itt').get('enabled').value &&
                              guarantee.get('itt').get('required').value,
                            'no-checked-required':
                              !guarantee.get('itt').get('enabled').value &&
                              guarantee.get('itt').get('required').value,
                          }"
                        >
                          <div class="box-garanties">
                            <div class="label-and-checkbox">
                              <span>ITT</span>
                              <input
                                type="checkbox"
                                formControlName="enabled"
                                class="large-checkbox"
                              />
                            </div>
                            <mat-select formControlName="deductible">
                              @for (option of deductibleRef; track option) {
                                <mat-option [value]="option.id">
                                  {{ option.label }}
                                </mat-option>
                              }
                            </mat-select>
                          </div>
                        </td>
                        <td
                          formGroupName="pe"
                          [ngClass]="{
                            'checked-required':
                              guarantee.get('pe').get('enabled').value &&
                              guarantee.get('pe').get('required').value,
                            'no-checked-required':
                              !guarantee.get('pe').get('enabled').value &&
                              guarantee.get('pe').get('required').value,
                          }"
                        >
                          <div class="box-garanties">
                            <div class="label-and-checkbox">
                              <span>PE</span>
                              <input
                                type="checkbox"
                                formControlName="enabled"
                                class="large-checkbox"
                              />
                            </div>
                          </div>
                        </td>
                        <td
                          formGroupName="octc"
                          [ngClass]="{
                            'checked-required':
                              guarantee.get('octc').get('enabled').value &&
                              guarantee.get('octc').get('required').value,
                            'no-checked-required':
                              !guarantee.get('octc').get('enabled').value &&
                              guarantee.get('octc').get('required').value,
                          }"
                        >
                          <div class="box-garanties">
                            <div class="label-and-checkbox">
                              <span>OCTC</span>
                              <input
                                type="checkbox"
                                formControlName="enabled"
                                class="large-checkbox"
                              />
                            </div>
                          </div>
                        </td>
                        <td
                          formGroupName="dosPsy"
                          [ngClass]="{
                            'checked-required':
                              guarantee.get('dosPsy').get('enabled').value &&
                              guarantee.get('dosPsy').get('required').value,
                            'no-checked-required':
                              !guarantee.get('dosPsy').get('enabled').value &&
                              guarantee.get('dosPsy').get('required').value,
                          }"
                        >
                          <div class="box-garanties">
                            <div class="label-and-checkbox">
                              <span>DOS PSY</span>
                              <input
                                type="checkbox"
                                formControlName="enabled"
                                class="large-checkbox"
                              />
                            </div>
                          </div>
                        </td>
                        <td
                          formGroupName="senior"
                          [ngClass]="{
                            'checked-required':
                              guarantee.get('senior').get('enabled').value &&
                              guarantee.get('senior').get('required').value,
                            'no-checked-required':
                              !guarantee.get('senior').get('enabled').value &&
                              guarantee.get('senior').get('required').value,
                          }"
                        >
                          <div class="box-garanties">
                            <div class="label-and-checkbox">
                              <span>SENIOR</span>
                              <input
                                type="checkbox"
                                formControlName="enabled"
                                class="large-checkbox"
                              />
                            </div>
                          </div>
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
              <div class="row mt-4">
                <table class="table-bordered recap-table table w-full">
                  <thead>
                    <tr>
                      <th>Garantie</th>
                      <th>Description</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td><strong>DC/PTIA</strong></td>
                      <td>
                        Protéger mes ayants-droits en cas de décès et/ou perte
                        totale et irréversible d’autonomie
                      </td>
                    </tr>
                    <tr>
                      <td><strong>IPT</strong></td>
                      <td>
                        Bénéficier d’un capital en cas de perte de revenus suite
                        à une invalidité
                      </td>
                    </tr>
                    <tr>
                      <td><strong>IPP</strong></td>
                      <td>
                        Bénéficier d’un capital en cas de perte de revenus suite
                        à une invalidité
                      </td>
                    </tr>
                    <tr>
                      <td><strong>ITT</strong></td>
                      <td>
                        Maintenir mon niveau de vie en cas d’arrêt travail
                      </td>
                    </tr>
                    <tr>
                      <td><strong>PE</strong></td>
                      <td>Garantie perte d'emploi</td>
                    </tr>
                    <tr>
                      <td><strong>DOS PSY</strong></td>
                      <td>
                        Lever les éventuelles exclusions sur la durée
                        d’hospitalisation en cas d’arrêt de travail
                      </td>
                    </tr>
                    <tr>
                      <td><strong>SENIOR</strong></td>
                      <td>
                        Être couvert jusqu’à 70 ans en cas d’arrêt de travail
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </ng-container>
          </ng-container>
        }
      }
    </ng-container>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
